"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPageTimeFieldProps = exports.withPageDateInputFieldProps = exports.withPageDateFieldProps = exports.withChartFieldProps = exports.withImageFieldProps = exports.withFileFieldProps = exports.withPageNumberFieldProps = exports.withPageSelectFieldProps = exports.withPageTextInputFieldProps = exports.withPageTextFieldProps = exports.withPageGroupProps = void 0;
const page_renderer_1 = require("@terragotech/page-renderer");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const lodash_2 = require("lodash");
const client_1 = require("@apollo/client");
const client_2 = require("@apollo/client");
const configContext_1 = require("../../contexts/configContext");
const UserInfoContext_1 = require("../../contexts/UserInfoContext");
const gen5_datamapping_lib_1 = require("@terragotech/gen5-datamapping-lib");
const utils_1 = require("../../utils");
const FormHelpers_1 = require("../../components/Workflow/FormHelpers");
const useOptions = (optionDef, queryKey) => {
    const client = (0, client_1.useApolloClient)();
    // TODO: I don't like this. Options within form dropdowns, probably shouldn't be reading the accessors.
    const { accessors } = (0, page_renderer_1.usePageDataMappingSources)();
    const { aggregateDefinitions } = (0, configContext_1.useConfig)();
    const { username, roles } = (0, UserInfoContext_1.useUserInfo)();
    const optionsProvider = (0, react_1.useCallback)(async (params, endCursor, searchText) => {
        var _a;
        if (optionDef.type === gen5_datamapping_lib_1.SimpleOptionType) {
            return {};
        }
        // TODO use default filtering and mandatory filtering to generate the query not here though
        else if (optionDef.type === gen5_datamapping_lib_1.AggregateLoaderType) {
            try {
                const dataLoader = optionDef;
                const aggregateSource = (accessors.STATE && accessors.STATE()) || {};
                const queryKey = (_a = aggregateDefinitions.find(d => d.name === dataLoader.aggregateType)) === null || _a === void 0 ? void 0 : _a.queryKey;
                if (!queryKey) {
                    console.error('No query key found for 1', dataLoader.aggregateType);
                    return [];
                }
                const graphQlQuery = (0, utils_1.computeGraphQlQueryFromQueryDefinitionWithPagination)({
                    queryKey: queryKey,
                    queryDefinition: dataLoader.mandatoryFilter,
                    objectToMatchKeyWord: aggregateSource,
                    username,
                    userRoles: roles.map(role => role.name),
                    limit: FormHelpers_1.DATA_COUNT_PER_PAGE,
                    after: endCursor,
                    searchText: searchText,
                });
                const items = await client
                    .query({
                    query: (0, client_2.gql) `
                ${graphQlQuery.query}
              `,
                })
                    .then(response => {
                    const nodes = response.data[`${queryKey}Connection`]['nodes'];
                    const pageInfo = response.data[`${queryKey}Connection`]['pageInfo'];
                    const totalCount = response.data[`${queryKey}Connection`]['totalCount'];
                    const metadata = (accessors.METADATA && accessors.METADATA()) || {};
                    if (metadata.hasOwnProperty('aggregateType') &&
                        metadata.aggregateType === dataLoader.aggregateType) {
                        return {
                            items: nodes.filter(({ id }) => id !== aggregateSource.id),
                            pageInfo: Object.assign(Object.assign({}, pageInfo), { totalCount: totalCount }),
                        };
                    }
                    return { items: nodes };
                })
                    .then(graphQlData => {
                    const data = ((graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.items) || []).map(({ label, id }) => ({
                        label,
                        value: id,
                    }));
                    return Object.assign(Object.assign({}, graphQlData), { items: data });
                });
                return items;
            }
            catch (e) {
                console.error(e);
                return {};
            }
        }
        else if (optionDef.type === gen5_datamapping_lib_1.UserLoaderType) {
            try {
                const dataLoader = optionDef;
                const userSource = (accessors.STATE && accessors.STATE()) || {};
                const queryKey = 'usersSelect';
                const graphQlQuery = (0, utils_1.computeGraphQlQueryFromQueryDefinitionWithPagination)({
                    queryKey,
                    queryDefinition: dataLoader.mandatoryFilter,
                    objectToMatchKeyWord: userSource,
                    username,
                    userRoles: roles.map(role => role.name),
                    limit: FormHelpers_1.DATA_COUNT_PER_PAGE,
                    after: endCursor,
                    searchText: searchText,
                });
                const items = await client
                    .query({
                    query: (0, client_2.gql) `
                ${graphQlQuery.query}
              `,
                })
                    .then(response => {
                    const nodes = response.data[`${queryKey}Connection`]['nodes'];
                    const pageInfo = response.data[`${queryKey}Connection`]['pageInfo'];
                    const totalCount = response.data[`${queryKey}Connection`]['totalCount'];
                    return { items: nodes, pageInfo: Object.assign(Object.assign({}, pageInfo), { totalCount: totalCount }) };
                })
                    .then(graphQlData => {
                    const data = ((graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.items) || []).map(({ label, id }) => ({
                        label,
                        value: id,
                    }));
                    return Object.assign(Object.assign({}, graphQlData), { items: data });
                });
                return items;
            }
            catch (e) {
                console.error(e);
                return {};
            }
        }
        else {
            return {};
        }
    }, [optionDef, client, aggregateDefinitions, accessors]);
    const valueOptionsProvider = (0, react_1.useCallback)(async (value) => {
        var _a;
        if (optionDef.type !== gen5_datamapping_lib_1.AggregateLoaderType)
            return [];
        const dataLoader = optionDef;
        const queryKey = (_a = aggregateDefinitions.find(d => d.name === dataLoader.aggregateType)) === null || _a === void 0 ? void 0 : _a.queryKey;
        if (!queryKey) {
            console.error('No query key found for 2', dataLoader.aggregateType);
            return [];
        }
        const graphQlQuery = (0, utils_1.computeGraphQlQueryFetchAggregateTypeByIds)({
            queryKey,
            ids: Array.isArray(value) ? value : !(0, lodash_2.isNil)(value) ? [value] : [],
        });
        try {
            const items = await client
                .query({
                query: (0, client_2.gql) `
              ${graphQlQuery.query}
            `,
                variables: graphQlQuery.variables,
            })
                .then(response => {
                return response.data[queryKey].map(({ label, id }) => ({
                    label,
                    value: id,
                }));
            });
            return items;
        }
        catch (e) {
            console.error(e);
            return [];
        }
    }, [optionDef, client, aggregateDefinitions]);
    const options = (optionDef.type === gen5_datamapping_lib_1.SimpleOptionType ? optionDef.items : undefined);
    const dataProvider = optionDef.type !== gen5_datamapping_lib_1.SimpleOptionType && optionDef.type !== gen5_datamapping_lib_1.DynamicLoaderType
        ? {
            optionsProvider,
            valueOptionsProvider,
        }
        : undefined;
    return {
        options,
        dataProvider,
    };
};
const getErrorAndWarningProps = ({ errors, warnings, translateFunction, }) => {
    let helperText = '';
    if (errors && errors[0]) {
        helperText = errors[0];
    }
    else if (warnings && warnings[0]) {
        helperText = warnings[0];
    }
    if (translateFunction) {
        helperText = translateFunction(helperText);
    }
    return {
        error: !!(errors && errors[0]),
        warning: warnings && warnings[0] ? true : undefined,
        helperText,
    };
};
const useFilterPageTextFieldProps = (props, type) => {
    const { value, controlDefinition, warnings, readOnly, translateFunction = text => text } = props;
    const { label, placeholder, info, oneLine, truncate } = controlDefinition;
    const filteredProps = Object.assign(Object.assign({ type: type || 'text' }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { value,
        warnings,
        label,
        info, placeholder: placeholder || 'No Placeholder', readOnly,
        oneLine,
        truncate,
        translateFunction });
    return filteredProps;
};
const useFilterPageTextInputFieldProps = (props, type) => {
    const { value, controlDefinition, warnings, readOnly, translateFunction = text => text, onChange } = props;
    const { label, placeholder, info, oneLine, truncate } = controlDefinition;
    const filteredProps = Object.assign(Object.assign({ type: type || 'text' }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { value,
        warnings,
        label,
        info, placeholder: placeholder || 'No Placeholder', readOnly,
        oneLine,
        truncate,
        translateFunction,
        onChange });
    return filteredProps;
};
const useFilterPageSelectFieldProps = (props, type) => {
    const { value, controlDefinition, warnings, readOnly, translateFunction = text => text, onChange } = props;
    const { label, info, oneLine, truncate, options } = controlDefinition;
    const optionsList = useOptions(options);
    const filteredProps = Object.assign(Object.assign(Object.assign(Object.assign({ type: type || 'select' }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { value,
        warnings,
        label,
        info,
        readOnly,
        oneLine,
        truncate,
        translateFunction, multiSelect: type === 'multiselect' }), optionsList), { onChange });
    return filteredProps;
};
const useGroupProps = (props) => {
    const { controlDefinition, translateFunction = text => text } = props, moreProps = __rest(props, ["controlDefinition", "translateFunction"]);
    const { label } = controlDefinition;
    const filteredProps = Object.assign({ label,
        controlDefinition,
        translateFunction }, moreProps);
    return filteredProps;
};
const withPageGroupProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useGroupProps(Object.assign({ translateFunction }, props));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageGroupProps = withPageGroupProps;
const withPageTextFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withPageTextFieldProps = withPageTextFieldProps;
const withPageTextInputFieldProps = (Component, type, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextInputFieldProps(Object.assign({ translateFunction }, props), type);
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withPageTextInputFieldProps = withPageTextInputFieldProps;
const withPageSelectFieldProps = (Component, type, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageSelectFieldProps(Object.assign({ translateFunction }, props), type);
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withPageSelectFieldProps = withPageSelectFieldProps;
const withPageNumberFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'number');
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withPageNumberFieldProps = withPageNumberFieldProps;
const withFileFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'file');
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withFileFieldProps = withFileFieldProps;
const withImageFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'image');
        return (react_1.default.createElement(Component, Object.assign({}, Object.assign(Object.assign({}, filteredProps), { width: props.controlDefinition.width, height: props.controlDefinition.height }))));
    };
};
exports.withImageFieldProps = withImageFieldProps;
const withChartFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'chart');
        return (react_1.default.createElement(Component, Object.assign({}, Object.assign(Object.assign({}, filteredProps), { chartType: props.controlDefinition.chartType, chartOptions: props.controlDefinition.chartOptions, height: props.controlDefinition.height }))));
    };
};
exports.withChartFieldProps = withChartFieldProps;
const withPageDateFieldProps = (Component, translateFunction) => {
    return (props) => {
        const { value, controlDefinition, warnings, readOnly, defaultDateTimeFormat } = props;
        const valueToUse = value && (typeof value === 'number' || typeof value === 'string') ? new Date(value) : value;
        const { label, placeholder, info, oneLine, truncate } = controlDefinition;
        const filteredProps = Object.assign(Object.assign({ label,
            placeholder,
            info, value: valueToUse }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { warnings, onChange: lodash_1.noop, readOnly,
            oneLine,
            truncate,
            defaultDateTimeFormat,
            translateFunction });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageDateFieldProps = withPageDateFieldProps;
const withPageDateInputFieldProps = (Component, translateFunction) => {
    return (props) => {
        const { value, controlDefinition, warnings, readOnly, defaultDateTimeFormat, onChange } = props;
        const valueToUse = value && (typeof value === 'number' || typeof value === 'string') ? new Date(value) : value;
        const { label, placeholder, info, oneLine, truncate } = controlDefinition;
        const filteredProps = Object.assign(Object.assign({ label,
            placeholder,
            info, value: valueToUse }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { warnings,
            onChange,
            readOnly,
            oneLine,
            truncate,
            defaultDateTimeFormat,
            translateFunction });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageDateInputFieldProps = withPageDateInputFieldProps;
const withPageTimeFieldProps = (Component, translateFunction) => {
    return (props) => {
        const { value, controlDefinition, readOnly, defaultDateTimeFormat } = props;
        const { label, placeholder, info, oneLine, truncate } = controlDefinition;
        const valueToUse = value && typeof value === 'number' ? new Date(value) : null;
        const filteredProps = Object.assign(Object.assign({ value: valueToUse }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { onChange: lodash_1.noop, label,
            placeholder,
            info,
            readOnly,
            oneLine,
            truncate,
            defaultDateTimeFormat,
            translateFunction });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageTimeFieldProps = withPageTimeFieldProps;
//# sourceMappingURL=PageHelpers.js.map